module.exports = __webpack_public_path__ + "3741059a82432c82b22c1ded45bb524b.svg";